<template>
  <div class="page" ref="page">
    <div class="container">
      <div class="flex align-center mb-30">
        <img src="/images/weizhi.png" alt="" class="mr-10">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index.html' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/overallScheme.html' }">整装方案</el-breadcrumb-item>
          <el-breadcrumb-item>方案详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="section mb-90">
        <div class="flex h-400 mb-30">
          <div class="flex-column align-center h-100 mr-10">
            <div class="list-btn" @click="toPrev"><i class="el-icon-arrow-up"></i></div>
            <div class="list mtb-10 flex-1 h-0">
              <div class="flex-column align-center picList" :style="{transform: 'translateY('+ (-moveHeight) +'px)'}">
                <div class="case-item" :class="index === 0 ? '' : 'mt-10'" :style="{background:'url(' + Utils.IMG_PREV+item.pic + ') no-repeat center/cover'}" v-for="(item, index) in goodprogrammeInfo.programmePicList" :key="index"  @mouseenter="enter(index)">
                  <div class="w-100 h-100 flex align-center justify-center title color-ff font-12">
                    <!-- 客厅{{index+1}} -->
                  </div>
                </div>
              </div>
            </div>
            <div class="list-btn" @click="toNext"><i class="el-icon-arrow-down"></i></div>
          </div>
          <div class="pic mr-30" v-if="goodprogrammeInfo.programmePicList">
            <el-image :src="Utils.IMG_PREV+goodprogrammeInfo.programmePicList[currentImgIndex].pic" fit="cover" class="w-100 h-100"></el-image>
          </div>
          <div class="flex-1 w-0">
            <img src="/images/yinhao.png" alt="" class="mb-20">
            <div class="font-30 font-yahei color-292a2e mb-2">{{goodprogrammeInfo.name}}</div>
            <!-- <div class="font-16 color-292a2e font-yahei mb-28 flex">
              <div v-for="(home,homeIndex) in goodprogrammeInfo.newName" :key="homeIndex">{{home}}<span v-if="homeIndex+1<goodprogrammeInfo.newName.length">+</span></div>
              = {{goodprogrammeInfo.totalNum || 0}}件
            </div> -->
            <div class="flex align-center color-292a2e font-16 font-yahei mb-28">
              <div class="flex align-center flex-wrap" v-if="goodprogrammeInfo.programmeSpaceList && goodprogrammeInfo.programmeSpaceList.length>0">
                <span v-for="(item, index) in goodprogrammeInfo.programmeSpaceList" :key="index" class=" lh-24"><i class="el-icon-plus font-14 mlr-5" v-if="index !== 0"></i>{{item.name}}</span>
                <span class="mlr-5">=</span> 
              </div>
              <span class="font-arial color-292a2e font-bold font-16 lh-24">{{goodprogrammeInfo.totalNum || 0}}</span>
              <span class="lh-24">件</span>
            </div>
            <div class="flex align-center mb-28">
              <div class="flex-column price">
                <span class="font-12 color-94">价格</span>
                <span class="font-12 color-94">区间</span>
              </div>
              <div class="font-30 color-c19357 font-arial">¥{{Utils.toFixedNum(goodprogrammeInfo.lowPrice)}}~{{Utils.toFixedNum(goodprogrammeInfo.hightPrice)}}</div>
            </div>
            <div class="recommend plr-30 flex align-center mb-30">
              <div>
                <div class="flex align-center mb-4">
                  <span class="color-94 font-12">推荐指数|</span>
                  <el-rate v-model="value" disabled :colors="['#c19357', '#c19357', '#c19357']" disabled-void-color="rgba(0,0,0,0.3)"></el-rate>
                </div>
                <div class="flex align-center">
                  <div class="tag-16-292a2e" v-for="(item, index) in goodprogrammeInfo.programmeTagList" :key="index">{{item.name}}</div>
                </div>
              </div>
              <div class="line"></div>
              <div>
                <div class="font-12 color-94 mb-6">设计风格</div>
                <div class="font-16 font-yahei color-292a2e">{{goodprogrammeInfo.style}}</div>
              </div>
              <div class="line"></div>
              <div>
                <div class="font-12 color-94 mb-6">房型</div>
                <div class="font-16 font-yahei color-292a2e">{{goodprogrammeInfo.layout}}</div>
              </div>
            </div>
            <div class="flex align-center"  v-if="goodprogrammeInfo.programmePanoramaList && goodprogrammeInfo.programmePanoramaList.length>0">
              <div class="vr-item mr-10 cursor" :style="{background:'url(' + Utils.IMG_PREV+goodprogrammeInfo.programmePicList[currentImgIndex].pic + ') no-repeat center/cover'}" v-for="(item, index) in goodprogrammeInfo.programmePanoramaList" :key="index">
                <div class="flex-column align-center justify-center w-100 h-100">
                  <img src="/images/vr.png" alt="" class="mb-4">
                  <span class="font-12 font-arial color-ff">VR全景{{index+1}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="hr-dashed mb-30"></div>
        <div class="flex align-center">
          <div class="bg-f9f4ee radius-4 color-c19357 font-16 introduce-icon flex-column align-center justify-center">
            <div>方案</div><div>介绍</div>
          </div>
          <div class="font-12 color-94 flex-1 w-0 lh-18">{{goodprogrammeInfo.profile}}</div>
        </div>
      </div>
      <div class="font-32 color-292a2e font-yahei mb-16 text-center">空间搭配方案</div>
      <div class="flex align-center justify-center room-list mb-90 flex-wrap">
        <div class="btn-40 font-16 radius-round plr-36 mr-10 mb-10" :class="roomIndex === index ? 'bg-c19357 color-ff' : 'border-292a2e'" v-for="(item, index) in goodprogrammeInfo.programmeSpaceList" :key="index">
          {{item.name}}
        </div>
        <div class="btn-40 w-40 radius-round bg-292a2e color-ff font-18 font-bold mb-10" @click="addRoom"><i class="el-icon-plus"></i></div>
      </div>
      <div class="room-section mb-90" v-for="(item, index) in goodprogrammeInfo.programmeSpaceList" :key="index">
        <div class="flex align-center mb-40">
          <img :src="Utils.IMG_PREV+item.icon" class="mr-10" style="width:47px;height:40px">
          <div class="font-32 color-292a2e font-yahei">{{item.name}}</div>
          <div class="line"></div>
          <div>
            <div class="font-16 color-292a2e"><span class="color-ff5555">{{item.spaceNum}}</span>件商品共</div>
            <div class="color-ff5555 font-16">¥{{Utils.toFixedNum(item.spacePrice)}}</div>
          </div>
          <div class="flex-1"></div>
          <div class="btn-40 bg-292a2e color-ff font-16 w-147 radius-round" @click="chooseGoods(item)">
            挑选更多
            <img src="/images/jinrubai.png" alt="" class="ml-10">
          </div>
          <div class="line" v-if="item.isNew"></div>
          <div class="btn-40 border-ff5555 font-16 w-122 radius-round" v-if="item.isNew" @click="deleteRoom(index)">删除空间</div>
        </div>
        <div class="mb-70 flex flex-wrap">
          <goods-edit ref="goodsEdit" v-for="(item1, goodIndex) in item.programmeSpaceGoodsList" :goodItem="item1" :key="goodIndex" :goodIndex="goodIndex" :index="index" @delete="deleteGoods(index,goodIndex)" @on-change="onChange" @on-choose="onChoose"></goods-edit>
        </div>
        <div class="hr-dashed"></div>
      </div>
    </div>
    <div class="settlement" :class="isFixed ? 'fixed' : ''" v-if="isShowSettle">
      <div class="container flex align-center justify-space-between h-100">
        <div class="flex-1 flex align-center">
          <img src="/images/fangan-heji.png" alt="" class="mr-15">
          <div>
             <div class="flex justify-center align-center color-292a2e font-16 font-yahei">
              <div class="flex align-center" v-if="MyCase.customerSpaceList && MyCase.customerSpaceList.length>0">
                <span v-for="(item, index) in MyCase.customerSpaceList" :key="index" class=" lh-24"><i class="el-icon-plus font-14 mlr-5" v-if="index !== 0"></i>{{item.name}}</span>
                <span class="mlr-5">=</span> 
              </div>
              <span class="font-arial color-292a2e font-bold font-16 lh-24">{{MyCase.totalNum || 0}}</span>
              <span class="lh-24">件</span>
            </div>
            <div class="flex align-center color-292a2e font-16 font-yahei">合计：<span class="font-22 font-arial">{{Utils.toFixedNum(MyCase.totalPrice)}}</span>元</div>
          </div>
        </div>
        <div class="font-16 color-292a2e mr-30 font-yahei">保存方案后，我们将会及时联系您，并为您的方案提供更完善可行的调整涉及！</div>
        <div class="btn-40 bg-292a2e color-ff w-172 radius-round font-yahei" @click="toSave">保存到我的方案</div>
      </div>
    </div>
    <div class="modal" v-if="isAddRoom" @scroll.stop.prevent @touchmove.prevent>
      <div class="content" style="height: auto">
        <div class="flex align-center justify-space-between p-10">
          <div class="font-16 color-292a2e font-yahei">新增空间</div>
          <img src="/images/guanbi.png" alt="" @click="onCloseAdd" class="cursor">
        </div>
        <div class="hr mb-20"></div>
        <div class="flex-column flex-1 ptb-28" style="max-height:450px;overflow-y: scroll;">
          <div :class="spaceIndex == index ? 'bg-c19357 color-ff':'border-292a2e'" class="btn-40 font-16 radius-round plr-36 mb-10 text-center mlr-30" style="line-height:38px" v-for="(item, index) in spaceList" :key="index" @click="selectSpace(index)">{{item.name}}</div>
        </div>
        <!-- <el-input v-model="roomName" class="font-40 text-center mtb-38" placeholder="点击输入(4字内)"></el-input> -->
        <div class="hr mb-20"></div>
        <div class="flex justify-center mb-20">
          <div class="btn-40 bg-292a2e font-16 color-ff radius-round w-153 font-yahei" @click="submitAddRoom">确定</div>
        </div>
      </div>
    </div>
    <div class="modal " v-if="isSaveSuccess" @scroll.stop.prevent @touchmove.prevent>
      <div class="content-save">
        <div class="flex justify-end p-10 mb-28">
          <img src="/images/guanbi.png" alt="" @click="onCloseSave" class="cursor">
        </div>
        <div class="flex-1 flex-column align-center justify-center">
          <img src="/images/chenggong.png" alt="" class="mb-16">
          <div class="font-22 color-292a2e font-yahei mb-4">保存成功</div>
          <div class="font-14 color-94 font-yahei">此方案已保存到我的方案中</div>
          <div class="font-14 color-94 font-yahei">请保持手机畅通，我们会及时联系您</div>
          <div class="font-14 color-94 font-yahei mb-60">并为您的方案提供更完善可行的调整设计！</div>
          <div class="btn-40 bg-292a2e font-16 color-ff radius-round plr-30 font-yahei" @click="lookMyCase">查看我的方案</div>
        </div>
      </div>
    </div>
    <goods-programme v-if="goodsShow" @on-colse="onColse" @on-add="onAdd" :currentSpace="currentSpace"></goods-programme>
  </div>
</template>


<script>
import GoodsEdit from '@/components/GoodsEdit'
import GoodsProgramme from '@/components/GoodsProgramme'
export default {
  name: 'SchemeDetail',
  components: {GoodsEdit,GoodsProgramme},
  data () {
    return {
      value: 5,
      vrList: [],
      room: [{
        name: '客厅'
      }, {
        name: '主卧'
      }, {
        name: '次卧'
      }, {
        name: '书房'
      }],
      roomIndex: 0,
      goodList: [],
      isAddRoom: false,
      roomName: '',
      isSaveSuccess: false,
      isFixed: true,
      windowHeight: null,
      isShowSettle: false,
      scrollHeight: 0,
      moveHeight: 0,
      id: '',
      goodprogrammeInfo: {},
      currentImgIndex: 0,
      spaceIndex: 0,
      spaceList: [],
      goodsShow: false,
      MyCase: {}
    }
  },
  created() {
    this.id = this.$route.query.id.slice(0,-5)
    if (this.id) {
      this.getProgramme()
    }
    this.getSpace()
  },
  mounted () {
    window.addEventListener("scroll",this.onScroll2)
    this.windowHeight = document.documentElement.clientHeight
  },
  beforeDestroy(){
    window.removeEventListener("scroll",this.onScroll2)
  },
  computed: {},
  methods: {
    getProgramme () {
      this.axios.post(`programme/getById`, this.qs.stringify({id: this.id})).then(res => {
        if (res.data.success) {
          let info = res.data.data
          let list = []
          let num = 0
          let price = 0
          for (let i=0;i<info.programmeSpaceList.length;i++) {
            list.push(info.programmeSpaceList[i].name)
            let spacePrice = 0
            let spaceNum = 0
            for (let j=0;j<info.programmeSpaceList[i].programmeSpaceGoodsList.length;j++) {
                spaceNum = spaceNum + info.programmeSpaceList[i].programmeSpaceGoodsList[j].quantity
                spacePrice =spacePrice + info.programmeSpaceList[i].programmeSpaceGoodsList[j].quantity * (info.programmeSpaceList[i].programmeSpaceGoodsList[j].isPeferential ? info.programmeSpaceList[i].programmeSpaceGoodsList[j].summaryPreferentialPrice : info.programmeSpaceList[i].programmeSpaceGoodsList[j].summaryPrice)
                info.programmeSpaceList[i].programmeSpaceGoodsList[j].programmeSpaceAttributeList = info.programmeSpaceList[i].programmeSpaceGoodsList[j].programmeSpaceAttributeList || info.programmeSpaceList[i].programmeSpaceGoodsList[j].newAttributeList
            }
            info.programmeSpaceList[i].spaceNum = spaceNum
            info.programmeSpaceList[i].spacePrice= spacePrice
            num = num + info.programmeSpaceList[i].spaceNum
            price = price + info.programmeSpaceList[i].spacePrice
          }
          info.newName = list
          info.totalNum = num
          info.totalPrice = price
          this.goodprogrammeInfo = info
          this.scrollHeight = (this.goodprogrammeInfo.programmePicList.length - 1) * 92 + 82
        }
      })
    },
    enter (index) {
      this.currentImgIndex = index
    },
    toNext () {
      if (this.scrollHeight < 320) {
        return
      } else {
        if (this.moveHeight + 260 < this.scrollHeight - 320) {
          this.moveHeight += 260
        } else {
          this.moveHeight = this.scrollHeight - 320
        }
      }
    },
    toPrev () {
      if (this.moveHeight - 260 > 0) {
        this.moveHeight -= 260
      } else {
        this.moveHeight = 0
      }
    },
    getSpace () {
      this.axios.post('space/list', {}).then(res => {
        if (res.data.success) {
          this.spaceList = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    selectSpace (index) {
      this.spaceIndex = index
    },
    addRoom () {
      this.isAddRoom = true
    },
    onCloseAdd () {
      this.isAddRoom = false
      this.spaceIndex = -1
    },
    submitAddRoom () {
      console.log(this.goodprogrammeInfo.programmeSpaceList)
      if (this.spaceIndex != -1) {
        for (let i=0;i<this.goodprogrammeInfo.programmeSpaceList.length;i++) {
          if (this.spaceList[this.spaceIndex].name == this.goodprogrammeInfo.programmeSpaceList[i].name) {
            this.$message({
                message: `${this.spaceList[this.spaceIndex].name}已存在`,
                type: "warn",
                offset: 400
              });
              return
          }
        }
        let room = this.spaceList[this.spaceIndex]
        room.programmeSpaceGoodsList = []
        room.isNew = true
        this.goodprogrammeInfo.programmeSpaceList.push(room)
      }
      this.onCloseAdd()
    },
     // 挑选更多
    chooseGoods (item) {
      this.goodsShow = true
      this.currentSpace = item
    },
    onChange () {
      this.onAdd()
    },
     onAdd () {
       console.log(this.goodprogrammeInfo)
      let info = this.goodprogrammeInfo
      let num = 0
      let price = 0
      for (let i=0;i<info.programmeSpaceList.length;i++) {
        let spacePrice = 0
        let spaceNum = 0
        for (let j=0;j<info.programmeSpaceList[i].programmeSpaceGoodsList.length;j++) {
            spaceNum = spaceNum + info.programmeSpaceList[i].programmeSpaceGoodsList[j].quantity
            spacePrice =spacePrice + info.programmeSpaceList[i].programmeSpaceGoodsList[j].quantity *  (info.programmeSpaceList[i].programmeSpaceGoodsList[j].isPeferential ? info.programmeSpaceList[i].programmeSpaceGoodsList[j].summaryPreferentialPrice : info.programmeSpaceList[i].programmeSpaceGoodsList[j].summaryPrice)
            info.programmeSpaceList[i].programmeSpaceGoodsList[j].programmeSpaceAttributeList = info.programmeSpaceList[i].programmeSpaceGoodsList[j].programmeSpaceAttributeList || info.programmeSpaceList[i].programmeSpaceGoodsList[j].newAttributeList
        }
        info.programmeSpaceList[i].spaceNum = spaceNum
        info.programmeSpaceList[i].spacePrice= spacePrice
        num = num + info.programmeSpaceList[i].spaceNum
        price = price + info.programmeSpaceList[i].spacePrice
      }
      info.totalNum = num
      info.totalPrice = price
      info.isShow = false
      this.goodprogrammeInfo = info
      console.log(this.goodprogrammeInfo)
    },
    onColse () {
      this.goodsShow = false
    },
    toSave () {
      if (this.$store.state.token && this.$store.state.user) {
        this.axios.post(`customerProgramme/save`, this.MyCase).then(res => {
          if (res.data.success) {
            this.isSaveSuccess = true
          } else {
            this.$message({
              message: res.data.msg,
              type: "warn",
              offset: 400
            });
          }
        })
      } else {
        this.$message({
              message: '此操作需要先登录',
              type: "warn",
              offset: 400
            });
      }
    },
     lookMyCase () {
       this.$router.push({path: '/myScheme.html'})
    },
    onCloseSave () {
      this.isSaveSuccess = false
    },
    deleteRoom (index) {
      this.goodprogrammeInfo.programmeSpaceList.splice(index,1)
      this.onAdd()
      this.handleGoods()
    },
    // 删除新加商品
    deleteGoods (index, goodIndex) {
      this.goodprogrammeInfo.programmeSpaceList[index].programmeSpaceGoodsList.splice(goodIndex, 1)
      this.onAdd()
      this.handleGoods()
    },
    // 选择商品到我的方案
    onChoose (e) {
      this.goodprogrammeInfo.programmeSpaceList[e.index].programmeSpaceGoodsList[e.goodIndex].selected = e.isSelect
      this.handleGoods()
    },
    handleGoods () {
      let list = this.goodprogrammeInfo.programmeSpaceList
      let MyCase = {
        customerId: this.$store.state.user.id,
        name: this.goodprogrammeInfo.name,
        totalNum: 0,
        totalPrice: 0
      }
      let customerSpaceList = []
      for (let i=0;i<list.length;i++) {
        let item = {
          id: list[i].id,
          caseId:  list[i].caseId,
          name:  list[i].name,
          icon:  list[i].icon,
          customerSpaceGoodsList: []
        }
        customerSpaceList.push(item)
        for (let j=0;j<list[i].programmeSpaceGoodsList.length;j++) {
          if (list[i].programmeSpaceGoodsList[j].selected) {
            list[i].programmeSpaceGoodsList[j].customerSpaceAttributeList = list[i].programmeSpaceGoodsList[j].programmeSpaceAttributeList
            MyCase.totalNum = MyCase.totalNum + list[i].programmeSpaceGoodsList[j].quantity
            MyCase.totalPrice = MyCase.totalPrice + (list[i].programmeSpaceGoodsList[j].quantity * (list[i].programmeSpaceGoodsList[j].isPeferential ? list[i].programmeSpaceGoodsList[j].summaryPreferentialPrice : list[i].programmeSpaceGoodsList[j].summaryPrice))
            customerSpaceList[i].customerSpaceGoodsList.push(list[i].programmeSpaceGoodsList[j])
          }
        }
      }
      MyCase.customerSpaceList = customerSpaceList
      this.MyCase = MyCase
    },
    onScroll2 () {
      this.pageHeight = this.$refs.page.offsetHeight
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 200) {
        this.isShowSettle = true
      } else {
        this.isShowSettle = false
      }
      if (scrollTop > (this.pageHeight - this.windowHeight)) {
        this.isFixed = false
      } else {
        this.isFixed = true
      }
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
  .page{
    padding: 30px 0 90px;
    background: #eeeff3;
    position: relative;
  }
  .section{
    background: #fff;
    border-radius: 4px;
    box-shadow: 0px 30px 70px 0px rgba(44, 51, 59, 0.07);
    padding: 30px;
    .introduce-icon{
      width: 50px;
      height: 50px;
      line-height: 18px;
      margin-right: 20px;
    }
    .list-btn{
      cursor: pointer;
      background:  #292a2e;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      i{
        color:#fff;
        font-size: 10px;
        font-weight: bold;
      }
      &:hover{
        background:  #c19357;
      }
    }
    .list{
      overflow: hidden;
    }
    .case-item{
      width: 124px;
      height: 82px;
      border-radius: 4px;
      flex-shrink: 0;
      overflow: hidden;
      cursor: pointer;
      .title{
        background: rgba($color: #000000, $alpha: 0.2);
        &:hover{
          background: rgba($color: #c19357, $alpha: 0.85);
        }
      }
    }
    .pic{
      width: 610px;
      height: 100%;
      border-radius: 4px;
      overflow: hidden;
    }
    .price{
      padding-right: 10px;
      margin-right: 10px;
      border-right: 1px solid #e9e9e9;
      line-height: 13px;
    }
    .recommend{
      background: #f9f4ee;
      border-radius: 4px;
      height: 96px;
      width: 100%;
      margin-top: -4px;
      .line{
        height: 40px;
        width: 1px;
        background: #e9e9e9;
        margin: 0 30px;
      }
    }
    .vr-item{
      width: 77px;
      height: 77px;
      border-radius: 50%;
      overflow: hidden;
      >div{
        background: rgba($color: #000000, $alpha: 0.5);
        &:hover{
          background: rgba($color: #c19357, $alpha: 0.85);
        }
      }
    }
  }
  .room-list{
    position: relative;
    &::after{
      content: '';
      display: block;
      width: 100%;
      height: 19px;
      position: absolute;
      top: 0;
      left: 0;
      border-bottom: 1px solid #e9e9e9;
    }
    .btn-40{
      z-index: 9;
    }
    .border-292a2e{
      background: #eeeff3;
    }
  }
  .room-section{
    .line{
      height: 40px;
      width: 1px;
      background: #cacaca;
      margin: 0 20px;
    }
    .btn-40:hover{
      background: #c19357;
    }
  }

  .settlement{
    height: 120px;
    width: 100%;
    background: #c19357;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .fixed{
    position: fixed;
    z-index: 10;
  }

  .modal{
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    .content{
      width: 394px;
      height: 253px;
      background: #ffffff;
      border-radius: 4px;
    }
    .content-save{
      width: 394px;
      height: 432px;
      background: #ffffff;
      border-radius: 4px;
    }
  }
  .picList{
    transition-duration: 0.5s;
  }

  .w-40{
    width: 40px;
  }
   .w-122{
    width: 122px;
  }
  .w-147{
    width: 147px;
  }
  .w-153{
    width: 153px;
  }
  .w-172{
    width: 172px;
  }
  .h-400{
    height: 400px;
  }

  ::v-deep{
    .content .el-input__inner{
      text-align: center;
      border: 0;
      height: 50px;
      line-height: 50px;
    }
  }
</style>
